// dashbaord
import Default from "../Components/Dashboard/Default";
import Ecommerce from "../Components/Dashboard/Ecommerce";

//widgets
import Chart from "../Components/Widgets/Chart";
import General from "../Components/Widgets/General";
import Dashboardindex from "../Components/Dashboard/Default/Dashboardindex";

import LineChartApex from "../Modules/charts/charts";

//Product

import ProductList from "../Modules/Product/Product";
import AddProduct from "../Modules/Product/Add";
import EditProduct from "../Modules/Product/Edit";
import ViewProduct from "../Modules/Product/View";
import Corporate from "../Modules/Corporate/Corporate";
import AddCorporate from  "../Modules/Corporate/Add";
import EditCorporate from "../Modules/Corporate/Edit";
import ViewCorporte from "../Modules/Corporate/View";
 import ProfilePage from "../Modules/Settings/ProfilePage";
 import AddPermission from "../Modules/Settings/Add";
 import PermissionLisitng from "../Modules/Settings/PermissionListing";
 import EditPermissions  from "../Modules/Settings/Edit";

 //Order
 import Order from "../Modules/Order/Order";
 import ViewOrder from "../Modules/Order/View";

 //ordertracking
 import OrderTracking from "../Components/Dashboard/Default/OrderTracking";
 import OrdersList from "../Components/Dashboard/Default/Order";
import BuyDevice from "../Components/BuyDevice/BuyDevice";
import Profile from "../Components/Profile/Profile";
import HelpCenter from "../Components/HelpCenter/HelpCenter";
import PrivacyPolicy from "../Components/Pages/PrivacyPolicy";


//landingPage

import LandingPage from "../Components/BuyDevice/LandingPage";

 

export const routes = [

  
  //dashboard
  {
    path: `${process.env.PUBLIC_URL}/dashboard/default`,
    Component: <Default />,
  },
  {
    path: `${process.env.PUBLIC_URL}/dashboard/ecommerce`,
    Component: <Ecommerce />,
  },

  {
    path: `${process.env.PUBLIC_URL}/dashboard/index`,
    Component: <Dashboardindex />,
  },
  


  // //widgets
  { path: `${process.env.PUBLIC_URL}/widgets/general`, Component: <General /> },
  { path: `${process.env.PUBLIC_URL}/widgets/chart`, Component: <Chart /> },

//Masters





//
{
  path: `/order-list`,
  Component: <OrdersList/>,
},
{
  path: `/profile`,
  Component: <Profile/>,
},
{
  path: `/buy`,
  Component: <BuyDevice/>,
},
{
  path: `/buy/:cid`,
  Component: <BuyDevice/>,
},
{
  path: `/help`,
  Component: <HelpCenter/>,
},




  //Corporate
  { path: `/corporates/add-corporate`, Component: <AddCorporate />,},
  { path: `/corporate/list`, Component: <Corporate />,},
  { path: `/corporate/edit-corporate/:cid`, Component: <EditCorporate />,},
  { path: `/corporate/view-corporate/:cid`, Component: <ViewCorporte />,},



  { path: `/product-list`, Component: <ProductList/>},
  { path: `/product-add`, Component: <AddProduct/>},
  { path: `/product-edit/:cid`, Component: <EditProduct/>},
  { path: `/product-view/:cid`, Component: <ViewProduct/>},
  
  //Users

 

 

 

  //orders

  
  {
    path: `/orders/orders-list`,
    Component: <Order/>,
  },
 //setting
  { path: "/orders/view-order/:cid", Component: <ViewOrder /> },
   { path : "/profile-page", Component: <ProfilePage/>},
   { path : "/permission-page", Component: <PermissionLisitng/>},
   { path : "/permission-add", Component: <AddPermission/>},
   { path : "/permission-edit/:cid", Component: <EditPermissions/>},
   //
   
   { path : "/order-tracking", Component: <OrderTracking/>},
   { path : "/home-page", Component: <LandingPage/>},

];
